const POINTS_PER_USD = 100;
const DEFAULT_USD_EXCHANGE_RATE = 1;
const DISPLAY_DECIMALS = 2;
const POINTS_PRECISION = 6;

const getSafeUsdExchangeRate = (usdExchangeRate: number): number =>
  usdExchangeRate > 0 ? usdExchangeRate : DEFAULT_USD_EXCHANGE_RATE;

const truncateCurrencyAmount = (amount: number): number => {
  const factor = Math.pow(10, DISPLAY_DECIMALS);
  return Math.floor((amount + Number.EPSILON) * factor) / factor;
};

/**
 * Convert a local-currency amount to whole points using the stored USD exchange rate.
 * We round up so reward eligibility stays aligned with the truncated local-currency balance display.
 * @param amount - The amount of currency to convert.
 * @param usdExchangeRate - The amount of local currency equal to 1 USD.
 * @returns The amount of points.
 */
export function convertCurrencyToPoints(
  amount: number,
  usdExchangeRate: number = DEFAULT_USD_EXCHANGE_RATE
): number {
  const safeExchangeRate = getSafeUsdExchangeRate(usdExchangeRate);
  const rawPoints = (amount / safeExchangeRate) * POINTS_PER_USD;
  return Math.ceil(Number(rawPoints.toFixed(POINTS_PRECISION)));
}

/**
 * Convert a points amount to local currency using the stored USD exchange rate.
 * @param amount - The amount of points to convert.
 * @param usdExchangeRate - The amount of local currency equal to 1 USD.
 * @returns The amount of currency.
 */
export function convertPointsToCurrency(
  amount: number,
  usdExchangeRate: number = DEFAULT_USD_EXCHANGE_RATE
): number {
  const safeExchangeRate = getSafeUsdExchangeRate(usdExchangeRate);
  return truncateCurrencyAmount((amount / POINTS_PER_USD) * safeExchangeRate);
}
